import { useMutation, UseMutationOptions, useQueryClient } from "@tanstack/react-query";
import { Topic } from "@/types";
import { api, UnprocessableEntityError } from "@/utils/api";
import { camelize } from "@/utils/api-helpers";

export type CreateTopicInput = {
  name: string;
};

export const useCreateTopic = (
  projectId: string,
  options: Omit<UseMutationOptions<Topic, UnprocessableEntityError, CreateTopicInput, unknown>, "mutationFn"> = {}
) => {
  const queryClient = useQueryClient();

  return useMutation<Topic, UnprocessableEntityError, CreateTopicInput, unknown>({
    mutationFn: async (input: CreateTopicInput): Promise<Topic> => {
      const response = await api.post<Topic>(`/projects/${projectId}/topics`, input);
      return camelize(response.data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["projects", projectId, "topics"],
      });
    },
    ...options
  });
};
